export default __webpack_public_path__ + "static/media/police-siren.783d29d7.png";